/**
 * Betslip Actions
 * @module modules/betslip/actions
 */

export const SET_MATCHED_BETS_FILTER = 'betslip/SET_MATCHED_BETS_FILTER';
export const SET_PLATFORM = 'betslip/SET_PLATFORM';
export const SET_EVENT_ID = 'betslip/SET_EVENT_ID';
export const SET_SPORT_ID = 'betslip/SET_SPORT_ID';
export const SET_SUBMIT_ALL_WARNING = 'betslip/SET_SUBMIT_ALL_WARNING';
export const SET_CANCEL_ALL_WARNING = 'betslip/SET_CANCEL_ALL_WARNING';
export const TOGGLE_BETSLIP = 'navigation/TOGGLE_BETSLIP';
export const TOGGLE_PINNING = 'navigation/TOGGLE_PINNING';

/**
 * Set whether to display the betslip on smaller devices all the time and on larger devices when
 * not pinned.
 * @param {boolean} payload - Boolean representing whether the betslip is displayed or not
 * @returns {object}
 */
export function toggleDisplay(payload = false) {
  return {
    type: TOGGLE_BETSLIP,
    payload
  };
}

/**
 * Set whether the betslip is pinned or not on larger devices.
 * @param {boolean} payload - Boolean representing whether the betslip is displayed or not
 * @returns {object}
 */
export function togglePinning(payload = false) {
  return {
    type: TOGGLE_PINNING,
    payload
  };
}

/**
 * Set the filter for the matched bets view.
 * @param {('all'|'avg'|'sum')} payload - String representing the filter we want to apply
 * @returns {Object}
 */
export function setMatchedBetsFilter(payload = 'all') {
  return {
    type: SET_MATCHED_BETS_FILTER,
    payload
  };
}

/**
 * Set the Event ID for which to we are filtering bets.
 * @param {String|number} payload - The id of the event we are filtering bets for.
 * @returns {Object}
 */
export function setEventId(payload = null) {
  return {
    type: SET_EVENT_ID,
    payload
  };
}

/**
 * Set the Sport ID for which to we are filtering bets.
 * @param {String|number} payload - The id of the sport we are filtering bets for.
 * @returns {Object}
 */
export function setSportId(payload = null) {
  return {
    type: SET_SPORT_ID,
    payload
  };
}

/**
 * Set whether or not we warn when you are about to batch submit bets.
 * @param {boolean} payload - Whether the setting is on or off.
 * @returns {Object}
 */
export function setSubmitAllWarning(payload = null) {
  return {
    type: SET_SUBMIT_ALL_WARNING,
    payload
  };
}

/**
 * Set whether or not we warn when you are about to cancel all bets.
 * @param {boolean} payload - Whether the setting is on or off.
 * @returns {Object}
 */
export function setCancelAllWarning(payload = null) {
  return {
    type: SET_CANCEL_ALL_WARNING,
    payload
  };
}
